export default {
  sm: `
  IT 서비스 환경 변화에 따른 데이터의 증가는
  네이버의 성장과 함께하였습니다.
  데이터센터 각은 네이버 사용자와 클라우드
  기업 고객에게 안정적인 서비스를 제공하고,
  증가하는 데이터를 효율적으로 관리하고
  저장하기 위해 2013년 각 춘천, 2023년
  각 세종을 건립하여 약 70만 유닛의 서버를
  수용할 수 있는 대규모 IT인프라를 구축하여
  운영하고 있습니다.
  `,
  lg: `
  IT 서비스 환경 변화에 따른 데이터의 증가는 네이버의
  성장과 함께하였습니다. 데이터센터 각은 네이버 사용자와
  클라우드 기업 고객에게 안정적인 서비스를 제공하고,
  증가하는 데이터를 효율적으로 관리하고 저장하기 위해
  2013년 각 춘천, 2023년 각 세종을 건립하여 약 70만
  유닛의 서버를 수용할 수 있는 대규모 IT인프라를 구축하여
  운영하고 있습니다.
  `,
  xxl: `
  IT 서비스 환경 변화에 따른 데이터의 증가는 네이버의 성장과
  함께하였습니다. 데이터센터 각은 네이버 사용자와 클라우드 기업
  고객에게 안정적인 서비스를 제공하고, 증가하는 데이터를 효율적으로
  관리하고 저장하기 위해 2013년 각 춘천, 2023년 각 세종을 건립하여
  약 70만 유닛의 서버를 수용할 수 있는 대규모 IT인프라를 구축하여
  운영하고 있습니다.
  `
};
